// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user__page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.user__page h1 {
  text-transform: uppercase;
  text-align: center;
}
.user__page .user__details {
  padding: 20px;
  background-color: #bf1a1a;
  border-radius: 1rem;
  width: 85vw;
  margin: 0 auto;
}
.user__page .user__details .user__table {
  background-color: white;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  color: black;
  margin-bottom: 8px;
  border-collapse: separate;
  border-radius: 0.5rem;
  text-align: center;
  table-layout: fixed;
}
.user__page .user__details .user__table thead tr .table__icon {
  color: #bf1a1a;
  margin: auto 0;
  font-size: 2rem;
}
.user__page .user__details .user__table td,
.user__page .user__details .user__table th {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 3px;
}
.user__page .user__details .user__table .btn_cell {
  display: flex;
  border: none;
}
.user__page .user__details .user__table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
}
.user__page .user__details .user__table tr:nth-child(even) {
  background-color: #f2f2f2;
}
.user__page .user__details .user__table .table_header {
  text-align: center;
  font-size: 1.5rem;
}
.user__page .user__details .user__table .cell_right {
  text-align: right;
  border-right: none;
}
.user__page .user__details .user__table .day_header th {
  text-align: center;
  background-color: grey;
  color: white;
}
@media (max-width: 690px) {
  .user__page .user__details .user__table {
    width: 100%;
    font-size: 0.65rem;
  }
  .user__page .user__details .user__table td,
  .user__page .user__details .user__table th {
    width: 10%;
  }
  .user__page .user__details .user__table .rota_dates {
    font-size: 0.5rem;
  }
  .user__page .user__details .user__table td .table_icon {
    margin-left: -25%;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .user__page .user__details .user__table {
    table-layout: fixed;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/user.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EC+BI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AD/BJ;AADE;EACE,yBAAA;EACA,kBAAA;AAGJ;AADE;EACE,aAAA;EACA,yBCVI;EDWJ,mBAAA;EACA,WAAA;EACA,cAAA;AAGJ;AADI;EACE,uBAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAGN;AAAU;EACE,cC5BJ;ED6BI,cAAA;EACA,eAAA;AAEZ;AAGM;;EAEE,sBAAA;EACA,aAAA;EACA,kBAAA;AADR;AAIM;EACE,aAAA;EACA,YAAA;AAFR;AAKM;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAHR;AAMM;EACE,yBAAA;AAJR;AAOM;EACE,kBAAA;EACA,iBAAA;AALR;AAQM;EACE,iBAAA;EACA,kBAAA;AANR;AASQ;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;AAPV;AAWI;EACE;IACE,WAAA;IACA,kBAAA;EATN;EAUM;;IAEE,UAAA;EARR;EAWM;IACE,iBAAA;EATR;EAYQ;IACE,iBAAA;EAVV;AACF;AAeI;EACE;IACE,mBAAA;EAbN;AACF","sourcesContent":["@import \"./variables.scss\";\n\n.user__page {\n  @include columnStartCenter;\n  h1 {\n    text-transform: uppercase;\n    text-align: center;\n  }\n  .user__details {\n    padding: 20px;\n    background-color: $rtRed;\n    border-radius: 1rem;\n    width: 85vw;\n    margin: 0 auto;\n\n    .user__table {\n      background-color: white;\n      font-family: Arial, Helvetica, sans-serif;\n      width: 100%;\n      color: black;\n      margin-bottom: 8px;\n      border-collapse: separate;\n      border-radius: 0.5rem;\n      text-align: center;\n      table-layout: fixed;\n      thead {\n        tr {\n          .table__icon {\n            color: $rtRed;\n            margin: auto 0;\n            font-size: 2rem;\n          }\n        }\n      }\n\n      td,\n      th {\n        border: 1px solid #ddd;\n        padding: 10px;\n        border-radius: 3px;\n      }\n\n      .btn_cell {\n        display: flex;\n        border: none;\n      }\n\n      th {\n        padding-top: 12px;\n        padding-bottom: 12px;\n        text-align: left;\n      }\n\n      tr:nth-child(even) {\n        background-color: #f2f2f2;\n      }\n\n      .table_header {\n        text-align: center;\n        font-size: 1.5rem;\n      }\n\n      .cell_right {\n        text-align: right;\n        border-right: none;\n      }\n      .day_header {\n        th {\n          text-align: center;\n          background-color: grey;\n          color: white;\n        }\n      }\n    }\n    @media (max-width: $mobile) {\n      .user__table {\n        width: 100%;\n        font-size: 0.65rem;\n        td,\n        th {\n          width: 10%;\n          // text-align: center;\n        }\n        .rota_dates {\n          font-size: 0.5rem;\n        }\n        td {\n          .table_icon {\n            margin-left: -25%;\n          }\n        }\n      }\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      .user__table {\n        table-layout: fixed;\n      }\n    }\n  }\n}\n","$rtRed: #bf1a1a;\n$rtBlack: #1d1d1d;\n$warning: #ff8808;\n$success: #00a74f;\n\n//Brand Colours\n$hr_dark_blue: #012748;\n$hr_blue: #0f4e6f;\n$hr_gold: #b66d2d;\n$hr_orange: #fe9816;\n$hr_yellow: #fede8c;\n\n//mobile breaks\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnEnd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin shadow {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
